// 지식베이스 관리(대표) — 시안 v6 #pg-kb. 탭: 문서 · 매장. 계약 §9. (FAQ 관리는 2026-10-14 뺌 — 가맹점주 첫 메뉴가 빠른 지원 카테고리로 바뀜)
import { useCallback, useEffect, useState } from "react";
import AdminGate from "../../v6common/AdminGate";
import { listDocs, storeStats } from "./api";
import { nf } from "./parts";
import Docs from "./Docs";
import Stores from "./Stores";
import "../../../admin_styles/inquiry_renewal.css";
import "../../../admin_styles/admin_v6.css";

const TABS = [
    ["doc", "fa-file-lines", "문서 관리"],
    ["store", "fa-store", "매장 관리"],
];

function Body() {
    const [tab, setTab] = useState("doc");
    const [counts, setCounts] = useState({ docs: null, stores: null });

    const loadCounts = useCallback(() => {
        listDocs({ status: "active" }).then((l) => setCounts((c) => ({ ...c, docs: l.length }))).catch(() => {});
        storeStats().then((s) => setCounts((c) => ({ ...c, stores: s.total }))).catch(() => {});
    }, []);
    useEffect(() => { loadCounts(); }, [loadCounts]);

    const show = (n) => (n == null ? "-" : nf(n));
    return (
        <>
            <div className="top">
                <div><h1>지식베이스 관리</h1><p>파일을 올리면 즉시 챗봇 답변에 활용됩니다. 매장은 앱 첫 로그인·전화 문의 조회·직접 등록으로 들어옵니다</p></div>
                <div className="top-act">
                    <div className="mini">
                        <div>활성 문서<b>{show(counts.docs)}</b></div>
                        <div>매장<b>{show(counts.stores)}</b></div>
                    </div>
                    <span className="pill-ok">상태 <b>정상</b></span>
                </div>
            </div>
            <div className="panel">
                <div className="subtabs">
                    {TABS.map(([k, ic, label]) => (
                        <button key={k} className={`tab${tab === k ? " on" : ""}`} onClick={() => setTab(k)}><i className={`fa-solid ${ic}`}></i>{label}</button>
                    ))}
                </div>
                {tab === "doc" && <Docs onChanged={loadCounts} />}
                {tab === "store" && <Stores onChanged={loadCounts} />}
            </div>
        </>
    );
}

// eslint-disable-next-line no-unused-vars
export default function KnowledgePage({ go }) {
    return (
        <main className="inq-r">
            <AdminGate ownerOnly>{() => <Body />}</AdminGate>
        </main>
    );
}
